import { QueryFactory } from '@lmt/shared-types';
import {
  Button,
  ButtonColor,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { localizeCaseTitle } from '@lmt/unicorn-shared/app/helpers/localization/translations';
import React, { FC } from 'react';
import { CaseTab } from './CaseTab';

import styles from './CaseBar.module.scss';

interface CaseBarProps {
  patientId: number;
  currentCaseId?: number | null;
  addCase: () => void;
  openCaseTab: (caseId: number) => void;
}

export const CaseBar: FC<CaseBarProps> = React.memo(function CaseBar(props) {
  const casesQuery = QueryFactory.CaseQuery.useGetCasesQuery({
    patientId: props.patientId,
  });
  const i18next = useScopedTranslation('patients.cases');

  return (
    <div className={styles.container}>
      <div className={styles.casesContainer}>
        <div className={styles.cases}>
          {casesQuery.data &&
            casesQuery.data.data.map((patientCase) => (
              <CaseTab
                key={patientCase.id}
                isSelected={patientCase.id === props.currentCaseId}
                title={localizeCaseTitle(patientCase)}
                onClick={props.openCaseTab}
                caseId={patientCase.id}
              />
            ))}
        </div>
        <div className={styles.emptyPlace}></div>
      </div>

      <div className={styles.controls}>
        <Button
          title={i18next.t('create_button')}
          color={ButtonColor.Primary}
          className={styles.addCaseButton}
          onClick={props.addCase}
        />
      </div>
    </div>
  );
});
